<div [hidden]="!hasAnnouncements">
    @for (item of announcements | method: OrderAnnouncements; track item) {
        @let announcement = item | method: GetAnnouncementByKind;
        <ng-container *ngTemplateOutlet="announcementShellTemplate; context: { $implicit: announcement }"></ng-container>
    }
</div>

<ng-template
    #announcementShellTemplate
    let-announcement>
    <div
        [ngClass]="{
            'sb-announcement': announcement.Mode === AnnouncementMode.Default && !isMobileOrTablet,
            'sb-announcement-mobile': announcement.Mode === AnnouncementMode.Default && isMobileOrTablet,
            'sb-announcement-tracker': announcement.Mode === AnnouncementMode.Tracker && !isMobileOrTablet,
            'sb-announcement-tracker-mobile': announcement.Mode === AnnouncementMode.Tracker && isMobileOrTablet,
            'sb-announcement-danger': announcement.Kind === StatusKind.Danger,
            'sb-announcement-warning': announcement.Kind === StatusKind.Warning,
            'sb-announcement-brand': announcement.Kind === StatusKind.Brand,
            'sb-announcement-light': announcement.Kind === StatusKind.Light
        }">
        <div [ngClass]="{ 'd-flex justify-content-between': isMobileOrTablet, 'w-100': !isMobileOrTablet }">
            <div [ngClass]="{ 'sb-announcement-title-wrapper': !isMobileOrTablet, 'sb-announcement-title-wrapper-mobile': isMobileOrTablet }">
                <div [ngClass]="{ 'sb-announcement-icon-wrapper-mobile': isMobileOrTablet }">
                    <lib-icon
                        [icon]="announcement.Icon"
                        [size]="IconSize.Small"></lib-icon>
                </div>

                <div [ngClass]="{ 'sb-announcement-text-wrapper': !isMobileOrTablet, 'sb-announcement-text-wrapper-mobile': isMobileOrTablet }">
                    @if (announcementTitleTemplate) {
                        <h6>
                            @if (announcement.Announcement === AnnouncementKind.Offline) {
                                <span i18n="@@CommonAnnouncementInternetConnectionLostTitle">Your internet connection is lost</span>
                            } @else if (announcement.Announcement === AnnouncementKind.PracticeTimer) {
                                <span class="sb-announcement-title-tracker"><ng-container *ngTemplateOutlet="announcementTitleTemplate; context: { $implicit: announcement.Announcement }"></ng-container></span>
                            } 
                            @else {
                                <ng-container *ngTemplateOutlet="announcementTitleTemplate; context: { $implicit: announcement.Announcement }"></ng-container>
                            }
                        </h6>
                    }
                    @if (announcementTextTemplate && !isMobileOrTablet) {
                        @if (
                            announcement.Announcement !== AnnouncementKind.Offline &&
                            announcement.Announcement !== AnnouncementKind.PaymentFailed &&
                            announcement.Announcement !== AnnouncementKind.TrialExpiry &&
                            announcement.Mode !== AnnouncementMode.Tracker
                        ) {
                            <p><ng-container *ngTemplateOutlet="announcementTextTemplate; context: { $implicit: announcement.Announcement }"></ng-container></p>
                        } @else if (announcement.Mode === AnnouncementMode.Tracker) {
                            <ng-container *ngTemplateOutlet="announcementTextTemplate; context: { $implicit: announcement.Announcement }"></ng-container>
                        }
                    }
                </div>
            </div>
            @if (isMobileOrTablet) {
                <ng-container *ngTemplateOutlet="dismissButtonTemplate; context: { $implicit: announcement }"></ng-container>
            }
        </div>
        @if (announcementTextTemplate && isMobileOrTablet) {
            @if (
                announcement.Announcement !== AnnouncementKind.Offline &&
                announcement.Announcement !== AnnouncementKind.PaymentFailed &&
                announcement.Announcement !== AnnouncementKind.TrialExpiry &&
                announcement.Mode !== AnnouncementMode.Tracker
            ) {
                <p><ng-container *ngTemplateOutlet="announcementTextTemplate; context: { $implicit: announcement.Announcement }"></ng-container></p>
            } @else if (announcement.Mode === AnnouncementMode.Tracker) {
                <ng-container *ngTemplateOutlet="announcementTextTemplate; context: { $implicit: announcement.Announcement }"></ng-container>
            }
        }

        <div
            [ngClass]="{
                'sb-announcement-button-wrapper': !isMobileOrTablet || announcement.Mode === AnnouncementMode.Tracker,
                'sb-announcement-button-wrapper-mobile': isMobileOrTablet && announcement.Mode !== AnnouncementMode.Tracker
            }">
            @if (announcementButtonGroupTemplate) {
                <ng-container *ngTemplateOutlet="announcementButtonGroupTemplate; context: { $implicit: announcement.Announcement }"></ng-container>
            }
            @if (!isMobileOrTablet) {
                <ng-container *ngTemplateOutlet="dismissButtonTemplate; context: { $implicit: announcement }"></ng-container>
            }
        </div>
    </div>
</ng-template>

<ng-template
    #dismissButtonTemplate
    let-announcement>
    @if (announcement.Dismissible) {
        <lib-icon-button
            [icon]="Icon.Common.Close"
            [kind]="ButtonKind.NeutralTertiary"
            (clicked)="DismissClicked(announcement.Announcement)"></lib-icon-button>
    }
</ng-template>
